import { pick } from 'util/objects'
import { createBasicSelector } from 'util/redux'
import { selectQueryParams } from 'selectors/location'
import { selectOnboarding } from '../../selectors'

const DEFAULT_FORM_FIELDS = {
  firstLastNameInput: '',
  usernameInput: '',
  passwordInput: '',
}

export const selectBase = createBasicSelector(
  selectOnboarding,
  onboarding => onboarding.acceptInvite
)

export function selectFormFields(state) {
  return pick(
    ['firstLastNameInput', 'usernameInput', 'passwordInput'],
    { ...DEFAULT_FORM_FIELDS, ...selectBase(state) },
    true
  )
}

export const selectAcceptError = createBasicSelector(
  selectBase,
  base => base.acceptError
)

export const selectInvitationToken = createBasicSelector(
  selectQueryParams,
  params => params.invitation_token
)

export const selectInvitationFound = createBasicSelector(selectBase, base => {
  return base.invitationFound
})

export const selectIsLoading = createBasicSelector(selectBase, base => {
  return base.isLoading
})
